import { createBoardPresentation } from './create'

export const presentations = {
  createBoardPresentation,
}
